var map = {
	"./demos/basic/index.ts": 38640,
	"./demos/counts/index.ts": 96361,
	"./demos/current/index.ts": 38916,
	"./demos/goto/index.ts": 52371,
	"./demos/noBoard/index.ts": 67826,
	"./demos/simple/index.ts": 9974,
	"./demos/size/index.ts": 87476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52475;